import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="bg-slate-100 px-4 py-6 md:px-12 md:py-8" data-id="element-213" data-mp="20qnmhm6g4bn0">
      <h2 className="mx-auto max-w-[600px] text-center text-[22px] font-extrabold uppercase leading-[1.25] tracking-[-0.3px] text-blue-950 md:text-[30px]" data-id="element-214" data-mp="1myzcbofrbx8o">
        What physical therapists are saying
      </h2>
      <div className="mt-3 space-y-2.5" data-id="element-215" data-mp="1d133x4e7fge9">
        {testimonials.map(t => <figure key={t.name} className="rounded-md border border-slate-200 bg-white px-3.5 py-3 md:px-4" data-id="element-216" data-mp="1i17ksvj0yd50">
            <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-217" data-mp="1427xpsb5u6ay">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden data-id="element-218" data-mp="1831k2h8yfd1q" data-mpi={i} />)}
            </div>
            <blockquote className="mt-1.5 text-[14px] leading-[1.45] text-slate-600 md:text-[15px]" data-id="element-219" data-mp="32gj07j7157mq">“{t.quote}”</blockquote>
            <figcaption className="mt-2" data-id="element-220" data-mp="2v0sun8y4a43d">
              <span className="block text-[12px] font-extrabold uppercase text-blue-950" data-id="element-221" data-mp="2uzhr9a8l2ycs">
                {t.name}, {t.age}
              </span>
              <span className="block text-[12px] leading-snug text-slate-600" data-id="element-222" data-mp="34rx8g5c23iwm">{t.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}